<template>
  <div id="random">
    <section class="hero is-primary is-bold">
      <div class="hero-head">
        <nav class="navbar">
          <div class="container">
            <div class="navbar-brand">
              <router-link :to="{name: 'Home'}" class="navbar-item">
                Crear
              </router-link>
              <a href="/random" class="navbar-item is-active">
                Random
              </a>
            </div>
          </div>
        </nav>
      </div>

      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            Pregunta random
          </h1>
        </div>
      </div>
    </section>

    <section class="section" v-if="id">
      <div class="container">
        <div class="card">
          <div class="card-content">
            <p class="title">
              “{{ question.question }}"
            </p>
          </div>
          <footer class="card-footer">
            <p class="card-footer-item">
              <span>
                {{ question.not }}
              </span>
            </p>
            <a href="#" class="card-footer-item" @click.prevent="active=true">
              {{ question.yes }}
            </a>
          </footer>
        </div>

        <button class="button is-primary is-fullwidth mt-5" id="copyLink"
          :data-clipboard-text="fullPage">
          Copiar link
        </button>
      </div>
    </section>

    <div v-if="id" id="modal" :class="['modal', {'is-active': active}]">
      <div class="modal-background" @click.prevent="active=false"></div>
      <div class="modal-content">
        <article :class="['notification is-light']">
          {{ question.confirm }}
        </article>
      </div>
      <button class="modal-close is-large" aria-label="close" @click.prevent="active=false">
      </button>
    </div>
  </div>
</template>

<script>

import Clipboard from 'clipboard';
import firebase from '../firebaseConfig';

export default {
  name: 'Random',
  data() {
    return {
      question: {},
      id: null,
      loading: false,
      active: false,
      fullPage: '',
      clipboard: null,
      randomNumbers: [],
      indexRandomNumbers: '_randomNumbers',
    };
  },
  created() {
    this.randomNumbers = JSON.parse(this.$localStorage.get(this.indexRandomNumbers, '[]'));
    this.getRandom();
  },
  mounted() {
    // init clipboard
    if (this.clipboard === null) {
      this.clipboard = new Clipboard('#copyLink');
      this.clipboard.on('success', (e) => {
        this.$toastr.s({
          title: 'El link ha sido copiado',
          msg: e.text,
        });
      });
    }
  },
  methods: {
    getRandom() {
      this.loading = true;
      const random = this.random();

      firebase
        .firestore()
        .collection('questions')
        .where('date', '>=', random)
        .orderBy('date')
        .limit(1)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            this.id = doc.id;
            this.question = doc.data();
            this.fullPage = `${window.location.origin}/${this.id}`;

            this.$localStorage.set(doc.id, JSON.stringify(doc.data()));

            this.loading = false;
          });
        });
    },
    random() {
      const min = 1593111852633;
      const max = Date.now();

      let random = Math.floor(Math.random() * (max - min + 1) + min);

      if (this.randomNumbers.includes(random)) {
        random = this.random();
      } else {
        this.randomNumbers.push(random);
        this.$localStorage.set(this.indexRandomNumbers, JSON.stringify(this.randomNumbers));
      }

      return random;
    },
  },
};
</script>
